import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SnackService } from './snack.service';
import { serverurl } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PromptService {

  constructor(
    private http: HttpClient,
    private snack: SnackService
  ) { }

  async savePrompt(id: any, targetId: string, agentId: string, promptType: string, orderNr: number, prompt: string, creditCosts: number, status: string | null, outputType: string | null) {
    return await new Promise((resolve) => {
      this.http.post(serverurl + '/tracks/prompt', { id, targetId, agentId, promptType, orderNr, prompt, creditCosts, status, outputType }).subscribe({
        next: (data: any) => {
          this.snack.success(data)
          resolve(data)
        },
        error: (err) => {
          this.snack.error(err);
          resolve(false);
        }
      })
    })
  }

  async deletePromptById(id: string) {
    return await new Promise((resolve) => {
      this.http.delete(serverurl + `/tracks/prompt/${id}`).subscribe({
        next: (data: any) => {
          this.snack.success(data)
          resolve(data)
        },
        error: (err) => {
          this.snack.error(err);
          resolve(false);
        }
      })
    })
  }
  async getPromptsByTargetId(id: string) {
    return await new Promise((resolve) => {
      this.http.get(serverurl + `/tracks/prompt/${id}`).subscribe({
        next: (data: any) => {
          resolve(data)
        },
        error: (err) => {
          this.snack.error(err);
          resolve(false);
        }
      })
    })
  }
  async getHistoryDataByPromptId(id: string) {
    return await new Promise((resolve) => {
      this.http.get(serverurl + `/tracks/prompt/history/promptid/${id}`).subscribe({
        next: (data: any) => {
          resolve(data)
        },
        error: (err) => {
          this.snack.error(err);
          resolve(false);
        }
      })
    })
  }
  async getHistoryDataByTargetId(id: string): Promise<any[] | false> {
    return await new Promise((resolve) => {
      this.http.get(serverurl + `/tracks/prompt/history/targetid/${id}`).subscribe({
        next: (data: any) => {
          resolve(data)
        },
        error: (err) => {
          this.snack.error(err);
          resolve(false);
        }
      })
    })
  }
}
